/** Libellé + indice optionnel au-dessus d'un champ (lecture ou saisie). */
export function FormField({ label, hint, className = "", children }) {
  return (
    <label className={`block ${className}`}>
      <div className="text-xs font-semibold text-slate-700 mb-1">
        {label}
        {hint && <span className="text-slate-400 font-normal ml-1">— {hint}</span>}
      </div>
      {children}
    </label>
  );
}
